export const CAMPAIGNS_QUERY_ACTION_PARAM = {
    NAME: 'action',
    VALUES: {
        TRACK_CAMPAIGN: 'track_campaign'
    }
};
